<template>
  <span>
    <v-btn
      title="Click to copy"
      @click="copy"
      rounded
      depressed
      small
      :color="$vuetify.theme.isDark ? 'black' : color"
      :icon="icon"
      >{{ label }}<v-icon x-small>mdi-content-copy</v-icon></v-btn
    >
    <textarea style="display: none" :id="'copyInput-' + uuid">{{
      content
    }}</textarea>
    <v-snackbar v-model="success" class="copy-snackbar">{{
      successMessage
    }}</v-snackbar>
  </span>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
    },
    label: {
      type: String,
    },
    uuid: {
      type: String,
    },
    icon: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "grey lighten-5",
    },
    copySuccessMessage: {
      type: String,
      default: "Copied successfully, you can now paste anywhere",
    },
  },
  name: "copyBottun",
  data() {
    return {
      success: false,
      successMessage: "",
    };
  },
  methods: {
    copy() {
      const input = document.getElementById("copyInput-" + this.uuid);
      navigator.clipboard.writeText(input.textContent).then(() => {
        this.successMessage = this.copySuccessMessage;
        this.success = true;
      });
    },
  },
};
</script>
